import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import CustomBoard from "../../components/CustomBoard";
import CustomBoardNewLogin from "../../components/CustomBoardNewLogin";
import Color from "../../../utils/Color";
import "fontsource-muli";
import UserNameLogin from "./components/UserNameLogin";
import SingPass from "./components/SingPass";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import PhoneIcon from "@material-ui/icons/Phone";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as authSelector from "../../../common/selectors/auth";
import * as authAction from "../../../common/actions/auth";
import _ from "lodash";
import LoadingOverlay from "../../components/LoadingOverlay";
import Constant from "../../../utils/Constant";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import CryptoJS from "crypto-js";
import { Crypt, RSA } from "hybrid-crypto-js";
import JSEncrypt from "jsencrypt";
import CustomToast from "../../components/CustomToast";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import ShowMoreText from "react-show-more-text";
import Box from "@material-ui/core/Box";

const StyledTabs = withStyles((theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    borderRadius: 5,
    marginTop: 30,
    marginBottom: 30,

    [theme.breakpoints.down("sm")]: {
      minWidth: 300,
      maxWidth: 300,
    },
    minWidth: 400,
    maxWidth: 400,
  },
  indicator: {
    backgroundColor: "transparent",
  },
}))(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    color: "#2c3034",
    opacity: 0.45,
    ...getFontSize("large"),
    ...getFontWeight("800"),
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      minWidth: 150,
      maxWidth: 150,
    },
    minWidth: 200,
    maxWidth: 200,
    textTransform: "capitalize",
    fontFamily: "Muli",
    letterSpacing: "normal",
    borderBottom: "2px solid #AFAFAF",
    "&:hover": {},
    "&$selected": {
      color: "#00B4AF",
      borderBottom: "2px solid #00B4AF",
      //backgroundColor: Color.blueButtonColor,
      background: "#CCEEF180 0% 0% no-repeat padding-box",
    },
    "&:focus": {
      outline: "none",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const StyledTabV2 = withStyles((theme) => ({
  root: {
    color: "#2C3034",
    opacity: 0.45,
    ...getFontSize("large"),
    ...getFontWeight("800"),
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      minWidth: 150,
      maxWidth: 150,
    },
    minWidth: 200,
    maxWidth: 200,
    textTransform: "capitalize",
    fontFamily: "Muli",
    letterSpacing: "normal",
    borderBottom: "2px solid #AFAFAF",
    "&:hover": {},
    "&$selected": {
      color: "#2C3034",
      borderBottom: "2px solid #AFAFAF",
      //backgroundColor: Color.blueButtonColor,
      background: "#FEC32D 0% 0% no-repeat padding-box",
    },
    "&:focus": {
      outline: "none",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div {...other}>
      {value === index && <div style={{  }}>{children}</div>}
    </div>
  );
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: "",
      password: "",
      value: 0,
      height: 0,
      width: 0,
      decryptedPasscodeID: "",
      decryptedPasscode: "",
      decryptedAccountType: "",
      decryptedSessionID: "",
      decryptedNRIC: "",
      customToastStatus: false,
      toastMessage: "",
      decryptedAction: false,
      loginAction: false,
      error: false,
      errorMessage: "",
      singpassFailedLogin: false,
      localAuthClientID: "",
      localAuthRedirectURL: "",
      localAuthState: "",
      localSingPassID: false,
      localSingPassRedirectUrl: false,
      testSing: false,
      localMaintainMsg: [],
      isExpandMaintain: false,
      showPassword:false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  formatDate(date) {
    return (
      [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-") +
      "T" +
      [
        this.padTo2Digits(date.getHours()),
        this.padTo2Digits(date.getMinutes()),
        this.padTo2Digits(date.getSeconds()),
      ].join(":")
    );
  }

  componentDidMount() {
    this.props.getMaintenanceMsg();
    //console.log("TIME",this.formatDate(new Date()))
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    const { loginPortalRequest } = this.props;
    var authClientID = this.getUrlVars()["AuthClientId"];
    var authRedirectUrl = this.getUrlVars()["AuthRedirectUrl"];
    var authState = this.getUrlVars()["AuthState"];
    // var spState = this.getUrlVars()["SPState"];
    // if(spState !== undefined){
    //   window.location.href = process.env.REACT_APP_SING_PASS_REDIRECT_URLV2+`?SPState=${spState}`;
    // }
    this.setState({
      localAuthClientID: authClientID,
      localAuthRedirectURL: authRedirectUrl,
      localAuthState: authState,
    });

    loginPortalRequest(0, "", "", "");
    // const script = document.createElement("script");

    // script.src = process.env.REACT_APP_SING_PASS_SCRIPT_SRC;
    // script.async = true;
    // document.body.appendChild(script);
    this.setState({ value: 1 });
    this.setState({ value: 0 });
    this.setState({ testSing: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.testSing === true) {
      this.setState({ value: 1 });
      this.setState({ value: 0 });
      this.setState({ testSing: false });
    }
    if (prevProps.loginPortalData !== this.props.loginPortalData) {
      if (this.props.loginPortalData !== null) {
        const sinpassClientId = authSelector.loginPortalSingpassClientId(
          this.props.loginPortalData
        );
        const singpassRedirectUrl = authSelector.loginPortalSingpassRedirectUrl(
          this.props.loginPortalData
        );
        this.setState({
          localSingPassID: sinpassClientId,
          localSingPassRedirectUrl: singpassRedirectUrl,
        });
      }
    }

    // Handle generateLoginOtp response
    console.log("this.props.generateLoginOtpData",this.props.generateLoginOtpData,this.state.loginAction)
    if (prevProps.generateLoginOtpData !== this.props.generateLoginOtpData) {
      if (this.props.generateLoginOtpData !== null && this.state.loginAction === true) {
        const otpSuccess = this.props.generateLoginOtpData.success || this.props.generateLoginOtpData.Success;
        const otpData = this.props.generateLoginOtpData.data || this.props.generateLoginOtpData.Data;
        
        if (otpSuccess === true && otpData) {
          const twoFAReferenceCode = otpData.two_fa_reference_code;
          const mobile = otpData.mobile;
          
          // Store OTP reference data in localStorage
          localStorage.setItem('TwoFAReferenceCode', twoFAReferenceCode);
          localStorage.setItem('Mobile', mobile);
          
          // Redirect to LoginOTP page
          const { history } = this.props;
          history.push('/LoginOTP');
        } else {
          const errorMessage = this.props.generateLoginOtpData.message || this.props.generateLoginOtpData.Message || this.props.generateLoginOtpData.Data.Message;
          this.setState({
            error: true,
            errorMessage: errorMessage || "Failed to generate OTP. Please try again.",
            loginAction: false
          });
        }
      }
    }

    const {
      loginData,
      getSingPassLoading,
      getSingPassStatus,
      getSingPassData,
    } = this.props;

    // if (prevProps.loginData !== this.props.loginData) {
    //   if (this.props.loginStatus) {
    //     const loginRequestKey = authSelector.getLoginRequestKey(
    //       this.props.loginData
    //     );
    //     const twoFAReferenceCode = authSelector.getTwoFAReferenceCode(
    //       this.props.loginData
    //     );
    //     this.props.postConfirmLoginRequest(loginRequestKey, twoFAReferenceCode);
    //   }
    //   console.log("confirmLoginStatus", this.props.confirmLoginStatus);
    // }

    // if (this.state.loginAction === true && this.props.loginLoading === false) {
    //   if (this.props.loginData !== null) {
    //     const loginDataData = authSelector.getLoginDataData(
    //       this.props.loginData
    //     );
    //     const loginSuccess = authSelector.getLoginSuccess(this.props.loginData);

    //     const errorLoginData = authSelector.getMessage(loginDataData);
    //     const isMaybankAuthorization = authSelector.getLoginDataIsMaybankAutho(
    //       loginDataData
    //     );
    //     const token = authSelector.getLoginDataToken(loginDataData);
    //     //console.log("loginDataData",loginDataData)
    //     if (loginSuccess === false) {
    //       this.setState({
    //         //toastMessage: errorLoginData,
    //         error: true,
    //         errorMessage: errorLoginData,
    //       });
    //     } else if (this.state.localAuthClientID !== undefined) {
    //       if (token !== null && isMaybankAuthorization === true) {
    //         const { history } = this.props;
    //         const loginDataData = authSelector.getLoginDataData(
    //           this.props.loginData
    //         );
    //         const redirectUrl = authSelector.getLoginDataRedirectUrl(
    //           loginDataData
    //         );
    //         // history.push(
    //         //   "/AuthorizationMaybank?" +
    //         //     "AuthClientId=" +
    //         //     this.state.localAuthClientID +
    //         //     "&" +
    //         //     "AuthRedirectUrl" +
    //         //     this.state.localAuthRedirectURL +
    //         //     "&" +
    //         //     "AuthState" +
    //         //     this.state.localAuthState
    //         // );
    //         window.location.replace(redirectUrl);
    //         //location.href(redirectUrl)
    //         // history.push(
    //         //   redirectUrl
    //         // );
    //       } else if (token !== null && isMaybankAuthorization === false) {
    //         const { history } = this.props;
    //         const loginDataData = authSelector.getLoginDataData(
    //           this.props.loginData
    //         );
    //         const redirectUrl = authSelector.getLoginDataRedirectUrl(
    //           loginDataData
    //         );
    //         window.location.replace(redirectUrl);
    //       }
    //     } else if (loginSuccess === true) {
    //       // const loginRequestKey = authSelector.getLoginRequestKey(
    //       //   this.props.loginData
    //       // );
    //       // const twoFAReferenceCode = authSelector.getTwoFAReferenceCode(
    //       //   this.props.loginData
    //       // );
    //       // this.props.postConfirmLoginRequest(
    //       //   loginRequestKey,
    //       //   twoFAReferenceCode
    //       // );
    //       const loginDataData = authSelector.getLoginDataData(
    //         this.props.loginData
    //       );
    //       const sessionID = authSelector.getSessionID(loginDataData);
    //       const nric = authSelector.getNric(loginDataData);
    //       const needSetUserID = authSelector.getLoginDataNeedSetUserID(
    //         loginDataData
    //       );
    //       const isMasterAccount = authSelector.getLoginDataIsMasterAcc(
    //         loginDataData
    //       );

    //       const needExpiryWarning = authSelector.getPasscodeID(loginDataData);
    //       const isDirectClient = authSelector.getLoginDataDirectClient(
    //         loginDataData
    //       );
    //       const sessionExpiryWarning = authSelector.getLoginDataSessionExpiryWarning(
    //         loginDataData
    //       );
    //       const sessionExpiryEnd = authSelector.getLoginDataSessionExpiryEnd(
    //         loginDataData
    //       );

    //       const token = authSelector.getLoginDataToken(loginDataData);
    //       AuthManager.setNeedChangeUserID(needSetUserID);
    //       AuthManager.setToken(token);
    //       AuthManager.setSessionID(sessionID);
    //       AuthManager.setSetChangeUserID(needSetUserID);
    //       AuthManager.setIsMasterAccount(isMasterAccount);
    //       AuthManager.setDirectClient(isDirectClient);
    //       AuthManager.setExpiryWarning(sessionExpiryWarning);
    //       AuthManager.setExpiryEnd(sessionExpiryEnd);
    //       window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
    //     }
    //   }

    //   this.setState({ loginAction: false });
    // }

    // if (prevProps.confirmLoginData !== this.props.confirmLoginData) {
    //   if (this.props.confirmLoginStatus) {
    //     this.decryptConfirmLoginData();
    //   }
    // }

    if (
      getSingPassLoading === false &&
      getSingPassStatus === true &&
      getSingPassData !== null &&
      this.state.singpassFailedLogin === false
    ) {
      const errorMsg = authSelector.getSingPassDataErrorMsg(getSingPassData);
      if (errorMsg === "Your account is not registered.") {
        window.location.href =
          process.env.REACT_APP_LOGIN_BASE_URL + "/#/Registration";
        return;
      }
      if (errorMsg !== ("" || null)) {
        //alert(errorMsg);
        this.setState({
          customToastStatus: true,
          toastMessage: errorMsg,
          singpassFailedLogin: true,
        });
      }
    }

    if (prevProps.getMaintenanceMsgData !== this.props.getMaintenanceMsgData) {
      this.props.getMaintenanceMsgData.length > 0 && this.props.getMaintenanceMsgData.map((item, index) => {
        // if (
        //   new Date(this.formatDate(new Date())) >=
        //     new Date(item.Effective_Date) &&
        //   new Date(this.formatDate(new Date())) < new Date(item.End_Date)
        // ) {

        // }
      });
      this.setState({ localMaintainMsg: this.props.getMaintenanceMsgData?.MaintenanceMessage });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangeUserID = (event) => {
    this.setState({ userID: event.target.value });
  };

  onChangePassword = (event) => {
    this.setState({ password: event.target.value });
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue, singpassFailedLogin: false });
  };

  handleKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.keyCode === 13) {
      this.onClickLogin();
    }
  };

  onClickLogin = async () => {
    const {
      userID,
      password,
      localAuthClientID,
      localAuthRedirectURL,
      localAuthState,
    } = this.state;
    const { generateLoginOtp } = this.props;
    if (userID && password !== "") {
      try {
        // Call reCAPTCHA API to get the token
        const recaptchaToken = await window.grecaptcha.execute(
          "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
          { action: "WEB_LOGIN_GENERATE_OTP" }
        );
  
        if (!recaptchaToken) {
          this.setState({
            error: true,
            errorMessage: "Unable to verify reCAPTCHA. Please try again.",
          });
          return;
        }
  
        const submitData = {
          UserID: userID,
          Password: password,
          AppId: "778234A1-BB5E-47EB-8219-821211862A2D",
          AccountType: "Customer",
          AuthClientId: localAuthClientID,
          AuthRedirectUrl: localAuthRedirectURL,
          AuthState: localAuthState,
          RecaptchaToken: recaptchaToken
        };

        // Store login data in localStorage for later use
        localStorage.setItem('loginSubmitData', JSON.stringify(submitData));
        
        generateLoginOtp(submitData);
        this.setState({ loginAction: true });

      } catch (error) {
        this.setState({
          error: true,
          errorMessage: "Invalid Login ID or Password. Please re-enter.",
        });
      }
    } else {
      this.setState({
        error: true,
        errorMessage: "User ID and Password can not be empty.",
      });
    }
  };

  onClickForgotUserID = () => {
    const { history } = this.props;
    history.push("/ForgotUserID");
  };

  onClickForgotPassword = () => {
    const { history } = this.props;
    history.push("/ForgotPassword");
  };

  onClickRegisterNow = () => {
    const { history } = this.props;
    history.push("/Registration");
  };

  onClickTermOfUse = () => {
    const { history } = this.props;
    window.open(
      "https://www.etiqa.com.sg/useful-information/privacy-statement/"
    );
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

   handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

   handleClickShowPassword = () => {
   this.setState({showPassword:!this.state.showPassword})
  };


  renderMaintenanceChild = () => {
    const { classes } = this.props;
    
    const { isExpandMaintain } = this.state;
    const onClickExpandMaintenance = () => {  
      this.setState({ isExpandMaintain: !isExpandMaintain });
    };
    
    return (
      <div
      style={{
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: "0%",
        marginTop: "0%",
      }}
    >
      {this.state.localMaintainMsg.length > 0 ? (
        <Box
          //sx={{ width: 1 }}
          style={{
            backgroundColor: "#E5E4E2",
            paddingTop: 13,
            paddingLeft: 30,
            paddingRight: 30,
            paddingBottom: 7,
          }}
        >
          <CustomText design={classes.maintainSubStyle}>
              {this.state.localMaintainMsg.length > 0
                ? this.state.localMaintainMsg.map((item, index) => {
                    return new Date(this.formatDate(new Date())) >=
                      new Date(item.Effective_Date) &&
                      new Date(this.formatDate(new Date())) <
                        new Date(item.Expiry_Date) ? (
                      <Grid style={{ marginBottom: "1em" }}>
                        <ShowMoreText
                          lines={3}
                          more={"Show more"}
                          less={"Show less"}
                          onClick={onClickExpandMaintenance}
                          expanded={false}
                          truncatedEndingComponent={"... "}
                        >
                          <CustomText design={classes.maintainSubStyle}>
                            {item.Message}
                          </CustomText>
                        </ShowMoreText>
                      </Grid>
                    ) : (
                      false
                    );
                  })
                : false}
          </CustomText>
          
        </Box>
      ) : (
        false
      )}
    </div>
    );
  }
  renderChildren = (matchesXS) => {
    const { classes, loginPortalData, loginPortalLoading } = this.props;
    const { userID, password, value, error, errorMessage,showPassword } = this.state;

    const enableMaintenance = authSelector.loginPortalEnableMaintenance(
      loginPortalData
    );
    // const maintenanceMsg = authSelector.loginPortalMaintenanceMsg(
    //   loginPortalData
    // );
    const returnUrl = authSelector.loginPortalReturnUrl(loginPortalData);
    const sinpassClientId = authSelector.loginPortalSingpassClientId(
      loginPortalData
    );
    const singpassRedirectUrl = authSelector.loginPortalSingpassRedirectUrl(
      loginPortalData
    );
    const singpassUAT = authSelector.loginPortalSingPassUAT(loginPortalData);

    const handleUserGuide = () => {
      //alert("user guide");
      window.open(
        "https://www.etiqa.com.sg/about-tiqconnect/tiqconnect-user-guide/"
      );
    };

    const handleContactUs = () => {
      //alert("contact us");
      window.open("https://www.etiqa.com.sg/contact/");
    };

    const handleLearnMore = () => {
      window.open(
        "https://www.etiqa.com.sg/useful-information/online-security-tips/"
      );
    };

    const handleRedirectSingpass = () => {
      var spState = this.getUrlVars()["SPState"];
      if(spState !== undefined){
        window.location.href = process.env.REACT_APP_SING_PASS_REG_REDIRECT_URLV2+`?SPState=${spState}`;
      }else{
        window.location.href = process.env.REACT_APP_SING_PASS_REG_REDIRECT_URLV2;
      }
     
    };

    return (
      <div className={classes.mainCon}>
        {/* <Helmet>
          <meta
            http-equiv="Content-Security-Policy"
            content="default-src 'self'; script-src 'self' https://*.singpass.gov.sg 'unsafe-inline'; connect-src 'self' https://*.singpass.gov.sg https://*.akstat.io; style-src 'self' https://*.singpass.gov.sg 'unsafe-inline'; img-src 'self' https://*.singpass.gov.sg data:; font-src https://fonts.gstatic.com;"
          />
        </Helmet> */}
        {/* {window.innerWidth > 600 ? (
          false
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
              border: "1px solid #A7A5A5",
              borderRadius: 15,
              boxShadow: "3px 3px 6px #0000005A",
              marginBottom: 20,
              paddingLeft: "5%",
              paddingRight: "5%",
              marginLeft: "2%",
              marginRight: "2%",
              paddingBottom: "7%",
            }}
          >
            <div>
              <img
                src={Image.cyber}
                style={{
                  width: "180px",
                  height: "128px",
                  borderRadius: "20px",
                }}
              />
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#303030",
              }}
            >
              Are you CyberSafe?
            </div>
            <div style={{ marginTop: 5, fontSize: "14px" }}>
              Online scams and cyber threats are on the rise. Avoid getting
              “caught” on the Internet with these easy cybersecurity tips today.
            </div>
            <div
              style={{
                marginTop: 15,
                fontSize: "16px",
                backgroundColor: "#FDC22D",
                borderRadius: "6px",
                paddingTop: 5,
                paddingBottom: 7,
                marginLeft: "20%",
                marginRight: "20%",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={handleLearnMore}
            >
              Learn more
            </div>
          </div>
        )} */}

        {/* <CustomText design={classes.loginTextStyle}>Login</CustomText> */}
        <div style={{fontSize:'24px',fontWeight:'500'}}>Log in to your account with</div>
        {/* <div style={{marginTop:'1%',fontSize:'16px'}}><span>New user?</span><span style={{color:"#0EA5E9",cursor:'pointer',fontWeight:'500'}} onClick={this.onClickRegisterNow}> Register now</span></div> */}

        <TabPanel value={value} index={0} style={{marginTop:"5%"}}>
          <UserNameLogin
            userID={userID}
            password={password}
            onChangeUserID={this.onChangeUserID}
            onChangePassword={this.onChangePassword}
            enableMaintenance={enableMaintenance}
            onClickLogin={this.onClickLogin}
            onClickForgotUserID={this.onClickForgotUserID}
            onClickForgotPassword={this.onClickForgotPassword}
            onClickRegisterNow={this.onClickRegisterNow}
            onClickTermOfUse={this.onClickTermOfUse}
            handleKeypress={this.handleKeypress}
            handleMouseDownPassword={this.handleMouseDownPassword}
            handleClickShowPassword={this.handleClickShowPassword}
            showPassword={showPassword}
            error={error}
            errorMessage={errorMessage}
          />
        </TabPanel>

      
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            // marginTop: 35,
            marginBottom: 10,
          }}
        >
          <hr
            style={{
              width: "80%",
              border: "0.2px solid #E5E4E2",
              height: "0px",
            }}
          />
          <div style={{ marginLeft: 50, marginRight: 50, fontWeight: "500",marginTop:'-5px',color:'#686868' }}>
            Or
          </div>
          <hr
            style={{
              width: "80%",
              border: "0.2px solid #E5E4E2",
              height: "0px",
            }}
          />
        </div>

        <div
          //value={value}
          // onChange={this.handleChange}
          aria-label="ant example"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: window.innerHeight < 800 ? "6%" : "9%",
            marginTop: "2.5%",
            width:'100%'
          }}
        >
          {/* <StyledTabV2 label="SingPass" value={0} /> */}
          {/* <StyledTabV2 label="User Name" value={0} /> */}
          <img
            src={Image.singpassBtn}
            style={{ width: "100%", height: 56, cursor: "pointer" }}
            onClick={handleRedirectSingpass}
            //className={classes.imageStepStyle}
            //style={matchesMD ? { marginTop: 20 } : { marginBottom: 0 }}
          />
        </div>

        <div style={{fontSize:'16px',fontWeight:'bold',textAlign:'center',marginBottom:'1.5rem'}}>No Singpass? <span style={{color:'rgba(14, 165, 233, 1)',cursor:'pointer'}} onClick={this.onClickRegisterNow}>Register Here</span></div>
       

        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />

        {matchesXS ? (
          <Grid
            container
            direction={"row"}
            spacing={6}
            style={{ marginTop: 30 }}
          >
            {/* <Grid item>
              <Grid
                container
                direction={"row"}
                alignItems={"center"}
                style={{ cursor: "pointer" }}
                onClick={handleUserGuide}
              >
                <Grid item>
                  <LibraryBooksIcon className={classes.bottomImageStyle} />
                </Grid>
                <Grid item>
                  <CustomText design={classes.bottomTextStyle}>
                    User Guide
                  </CustomText>
                </Grid>
              </Grid>
            </Grid> */}

            <Grid item>
              <Grid
                container
                direction={"row"}
                alignItems={"center"}
                style={{ cursor: "pointer" }}
                onClick={handleContactUs}
              >
                <Grid item>
                  <PhoneIcon className={classes.bottomImageStyle} />
                </Grid>
                <Grid item>
                  <CustomText design={classes.bottomTextStyle}>
                    Contact Us
                  </CustomText>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        <div style={{fontSize:'14px',color:'#686868',textAlign:'center',paddingBottom:'1.2rem'}}>By logging in, you acknowledge that you have read, understood and agreed to our <span style={{textDecoration:'underline',fontWeight:"bold",cursor:'pointer'}} onClick={this.onClickTermOfUse}>Terms of Use.</span></div>

        {/* {enableMaintenance == true ? (
          <Grid style={{ marginTop: "2em" }}>
            <CustomText design={classes.maintainSubStyle}>
              {maintenanceMsg}
            </CustomText>
          </Grid>
        ) : (
          false
        )} */}

        {/* {this.state.localMaintainMsg.length > 0
          ? this.state.localMaintainMsg.map((item, index) => {
              return new Date(this.formatDate(new Date())) >=
                new Date(item.Effective_Date) &&
                new Date(this.formatDate(new Date())) <
                  new Date(item.Expiry_Date) ? (
                <Grid style={{ marginTop: "2em" }}>
                  <CustomText design={classes.maintainSubStyle}>
                    {item.Message}
                  </CustomText>
                </Grid>
              ) : (
                false
              );
            })
          : false} */}
      </div>
    );
  };

  render() {
    const {
      classes,
      matchesXS,
      loginLoading,
      confirmLoginLoading,
      getAuthTokenLoading,
      loginPortalLoading,
      generateLoginOtpLoading,
    } = this.props;
    const { height, width } = this.state;

    return (
      <div className={classes.root}>
        <CustomBoardNewLogin
          maintenanceChild={this.renderMaintenanceChild()}
          children={this.renderChildren()}
          height={height}
          width={width}
          directClient={false}
          isFixWidth={true}
        />

        {loginLoading ? <LoadingOverlay loading={true} /> : false}
        {confirmLoginLoading ? <LoadingOverlay loading={true} /> : false}
        {getAuthTokenLoading ? <LoadingOverlay loading={true} /> : false}
        {loginPortalLoading ? <LoadingOverlay loading={true} /> : false}
        {generateLoginOtpLoading ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  loginTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  maintainStyle: {
    ...getFontWeight("500"),
    fontSize: 14,
    textAlign: "left",
    color: "#F46A6A",
    marginBottom: "1em",
  },
  maintainSubStyle: {
    ...getFontWeight("600"),
    fontSize: 14,
    textAlign: "justify",
    color: Color.primaryTextColor,
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  mainCon:{
    [theme.breakpoints.down('sm')]: {
     padding:"0 1.5rem"
    }
  }
});

function mapStateToProps(state) {
  return {
    loginData: selector.getLoginData(state),
    loginLoading: selector.getLoginLoading(state),
    loginStatus: selector.getLoginStatus(state),
    confirmLoginData: selector.getConfirmLoginData(state),
    confirmLoginLoading: selector.getConfirmLoginLoading(state),
    confirmLoginStatus: selector.getConfirmLoginStatus(state),
    loginPortalData: selector.loginPortalData(state),
    loginPortalLoading: selector.loginPortalLoading(state),
    loginPortalStatus: selector.loginPortalStatus(state),
    getAuthTokenLoading: selector.getAuthTokenLoading(state),
    getAuthTokenData: selector.getAuthTokenData(state),
    getAuthTokenStatus: selector.getAuthTokenStatus(state),
    getSingPassLoading: selector.getSingPassLoading(state),
    getSingPassData: selector.getSingPassData(state),
    getSingPassStatus: selector.getSingPassStatus(state),
    generateLoginOtpData: selector.generateLoginOtpData(state),
    generateLoginOtpLoading: selector.generateLoginOtpLoading(state),
    generateLoginOtpStatus: selector.generateLoginOtpStatus(state),

    getMaintenanceMsgLoading: selector.getMaintenanceMsgLoading(state),
    getMaintenanceMsgData: selector.getMaintenanceMsgData(state),
    getMaintenanceMsgStatus: selector.getMaintenanceMsgStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    postLoginRequest: (
      userID,
      password,
      authClientID,
      authRedirectUrl,
      authState,
      recaptchaToken,
      code,
      referenceNumber
    ) =>
      dispatch(
        authAction.postLoginRequest(
          userID,
          password,
          authClientID,
          authRedirectUrl,
          authState,
          recaptchaToken,
          code,
          referenceNumber
        )
      ),
    generateLoginOtp: (submitData) =>
      dispatch(authAction.generateLoginOtp(submitData)),
    postConfirmLoginRequest: (loginRequestKey, twoFAReferenceCode) =>
      dispatch(
        authAction.postConfirmLoginRequest(loginRequestKey, twoFAReferenceCode)
      ),
    loginPortalRequest: (actionId, authClientId, authRedirectUrl, authState) =>
      dispatch(
        authAction.loginPortalRequest(
          actionId,
          authClientId,
          authRedirectUrl,
          authState,
        )
      ),
    getAuthTokenRequest: (nric) =>
      dispatch(authAction.getAuthTokenRequest(nric)),
    getMaintenanceMsg: () => dispatch(authAction.getMaintenanceMsg()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(Login)));
